import SoftwareTopics from './SoftwareTopics.vue';
import SoftwareTopic from './SoftwareTopic.vue';
import SoftwareDownload from './SoftwareDownload.vue';

export default function SoftwareRoutes() {
  return [
    {
      path: '',
      redirect: { name: 'softwareTopics' }
    },
    {
      path: 'topics',
      component: SoftwareTopics,
      name: 'softwareTopics'
    },
    {
      path: 'topic',
      component: SoftwareTopic,
      name: 'softwareTopic'
    },
    {
      path: 'download',
      component: SoftwareDownload,
      name: 'downloadSoftwareFile'
    }
  ]
}
